import { render, staticRenderFns } from "./Detailpm.vue?vue&type=template&id=61fb8319&scoped=true"
import script from "./Detailpm.vue?vue&type=script&lang=js"
export * from "./Detailpm.vue?vue&type=script&lang=js"
import style0 from "./Detailpm.vue?vue&type=style&index=0&id=61fb8319&prod&lang=scss"
import style1 from "./Detailpm.vue?vue&type=style&index=1&id=61fb8319&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61fb8319",
  null
  
)

export default component.exports